import { keys } from '@rehaje/shared'

import type { TRecord } from '@rehaje/shared'

let memoizedIdleId: number | undefined
const memoizedKeysCache = new Map<object, PropertyKey[]>()

export function getMemoizedKeys(target: TRecord): PropertyKey[] {
  const targetProxyRaw = target.__r_proxy_raw
  if (!targetProxyRaw) return keys(target)
  let targetKeys
  if (memoizedKeysCache.has(targetProxyRaw)) {
    targetKeys = memoizedKeysCache.get(targetProxyRaw)
  } else {
    targetKeys = keys(targetProxyRaw)
    memoizedKeysCache.set(targetProxyRaw, targetKeys)
    if (!memoizedIdleId) {
      memoizedIdleId = requestIdleCallback(() => {
        memoizedKeysCache.clear()
        memoizedIdleId = undefined
      })
    }
  }
  return targetKeys
}
